var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66535 13.9777C2.81798 11.3304 4.70719 9.25569 7.05905 9.12442C10.4647 8.93433 15.3324 8.70508 19 8.70508C22.6676 8.70508 27.5353 8.93433 30.9409 9.12442C33.2928 9.25569 35.182 11.3304 35.3346 13.9777C35.4809 16.514 35.625 19.6348 35.625 22.0835C35.625 24.5322 35.4809 27.653 35.3346 30.1893C35.182 32.8366 33.2928 34.9113 30.9409 35.0425C27.5353 35.2326 22.6676 35.4619 19 35.4619C15.3324 35.4619 10.4647 35.2326 7.05905 35.0425C4.70719 34.9113 2.81798 32.8366 2.66535 30.1893C2.51912 27.653 2.375 24.5322 2.375 22.0835C2.375 19.6348 2.51912 16.514 2.66535 13.9777Z",
    fill: "#FC0D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 16.7324L15.4375 27.4351L24.9375 22.0838L15.4375 16.7324Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6f8bb293782649df428617f290350e22.svg";
export { ForwardRef as ReactComponent };